function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PatternFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import { CreditCard as CreditCardIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import InputAdornment from "@mui/material/InputAdornment";
import { colors } from '../../theme/index.js';
import { styled } from '@mui/material/styles';
const StyledTextField = styled(TextField)(({
  theme
}) => ({
  '& .MuiInputBase-root': {
    fontFamily: '"AvenirLTPro-Book", sans-serif',
    fontWeight: "lighter",
    color: theme.palette.default.contrastText
  },
  "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
    borderColor: theme.palette.custom.textFieldHover
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
    borderColor: theme.palette.custom.textFieldHover,
    borderBottomWidth: "2px"
  }
}));

/**
 *
 * @param {*} props
 */
function CreditCardFormatCustom(props) {
  const {
    inputRef,
    onChange,
    ...other
  } = props;
  return /*#__PURE__*/React.createElement(PatternFormat, _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: values => {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    format: "#### #### #### ####",
    valueIsNumericString: true,
    mask: "_"
  }));
}

/**
 *
 * @param {*} props
 */
const CreditCardInput = props => props.creditCardSuccess ? /*#__PURE__*/React.createElement(TextField, {
  id: props.id || props.testid,
  select: props.select,
  error: Boolean(props.error),
  type: "text",
  label: props.label,
  autoFocus: props.autoFocus,
  autoComplete: props.autoComplete,
  value: props.value,
  margin: props.margin || 'normal',
  onChange: props.onChange,
  onKeyPress: props.onKeyPress,
  onBlur: props.onBlur,
  fullWidth: props.fullWidth,
  helperText: props.helperText || props.error,
  InputLabelProps: {
    shrink: props.value
  },
  InputProps: {
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(CreditCardIcon, {
      color: "secondary"
    })),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(CheckCircleIcon, {
      color: "secondary"
    })),
    inputComponent: CreditCardFormatCustom
  },
  sx: {
    "& .MuiOutlinedInput-root": {
      "& > fieldset": {
        borderColor: `${colors.brandGreen}`,
        borderWidth: 2,
        borderLeftWidth: 6
      }
    },
    "&:hover .MuiOutlinedInput-root": {
      "& > fieldset": {
        borderColor: `${colors.brandGreen}`
      }
    }
  },
  required: props.required,
  variant: "outlined",
  disabled: props.disabled,
  color: "secondary"
}) : /*#__PURE__*/React.createElement(StyledTextField, {
  id: props.id || props.testid,
  select: props.select,
  error: Boolean(props.error),
  type: "text",
  label: props.label,
  value: props.value,
  margin: props.margin || 'normal',
  onChange: props.onChange,
  onKeyPress: props.onKeyPress,
  onBlur: props.onBlur,
  fullWidth: props.fullWidth,
  helperText: props.helperText || props.error,
  InputProps: {
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(CreditCardIcon, {
      color: "primary"
    })),
    inputComponent: CreditCardFormatCustom
  },
  style: {
    backgroundColor: props.disabled ? '#f7f7f7' : null
  },
  required: props.required,
  variant: props.variant || 'standard',
  disabled: props.disabled
});
export default CreditCardInput;